import Quotes from './Quotes'
import Show from './Show'

export default {
    Quotes,
    Show
}
